import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import Button from "@/components/Button";
import Input from "@/components/Input";
import { ApiService } from "@/services/ApiService";
import { useTranslation } from "react-i18next";
// @ts-ignore
import { toast } from "sonner";

interface FrequenciaDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  licencaId: string | null;
  horasAgenteSegundos: number | null;
  onSuccess: () => void;
}

const FrequenciaDialog: React.FC<FrequenciaDialogProps> = ({ open, setOpen, licencaId, horasAgenteSegundos, onSuccess }) => {
  const { t } = useTranslation();
  const [frequenciaHoras, setFrequenciaHoras] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {     
    if (horasAgenteSegundos != null) {       
      const horas = Number(horasAgenteSegundos) / 3600;       
      const truncado = Math.floor(horas * 100) / 100;       
      setFrequenciaHoras(truncado.toFixed(2));     
    } else {       
      setFrequenciaHoras("");     
    }   
    
    setIsFocused(false);
  }, [horasAgenteSegundos]);

  const handleSubmit = async () => {
    const numeroHoras = parseFloat(frequenciaHoras);
    if (isNaN(numeroHoras) || numeroHoras <= 0) {
      toast.error(t("frequenciaDialog.messages.formatError"));
      return;
    }

    const segundos = Math.round(numeroHoras * 3600);
    setLoading(true);
    try {
      await ApiService.patch(`api/v1/licenca/${licencaId}/frequencia`, {
        horasAgente: segundos.toString()
      });
      toast.success(t("frequenciaDialog.messages.success.description"));
      setOpen(false);
      onSuccess(); 
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };


  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("frequenciaDialog.title")}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <Input
            id="frequencia"
            label={t("frequenciaDialog.inputs.frequencia.label")}
            type="text"
            placeholder="Ex: 2h, 1.5h, 30m"
            value={
              isFocused
                ? frequenciaHoras
                : frequenciaHoras
                  ? `${frequenciaHoras}h`
                  : ""
            }
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onChange={(e: any) => {
              const cleaned = e.target.value
                .replace("h", "")
                .replace(",", ".")
                .replace(/[^0-9.]/g, "");

              setFrequenciaHoras(cleaned);
            }}
          />
        </div>
        <DialogFooter>
          <Button label={t("frequenciaDialog.buttons.cancel")} onClick={() => setOpen(false)} color="neutro" />
          <Button label={t("frequenciaDialog.buttons.save")} onClick={handleSubmit} color="primario" disabled={loading} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FrequenciaDialog;